<template>
  <v-dialog persistent v-model="showDialog" max-width="700px">
    <v-card flat>
      <v-icon class="close" @click="showDialog = false; $emit('close')">$sl-close</v-icon>
      
      <h2>{{$t('company.employeedmodal.headline')}}</h2> 

      <v-card-text class="pl-0 pr-0">
        {{$t("company.employeedmodal.info-1")}}
        <br />
        <DatePicker 
          class="mt-12"
          :label="$t('labels.unlink3')" 
          :value="endDate"
          @input="endDate = $event"
          :hint="$t('hints.todaysDate')"
          persistentHint
        />
        <br />
        <strong>{{$t("company.employeedmodal.info-2")}}</strong>
      </v-card-text>
      <div>
        <ActionButton
          class="mt-4"          
          actionIcon="$sl-cancel"
          @click="showDialog = false; $emit('close')"
        >{{ $t('labels.cancel') }}</ActionButton>
        <ActionButton
          class="mt-4"
          type="application"
          actionIcon="$sl-unlink"
          @click="deleteEmployed"
        >{{ $t('labels.unlink2') }}</ActionButton>
        
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/services/api.js'
import ActionButton from '@/components/Common/ActionButton'
import DatePicker from '../Common/DatePicker.vue'
// @group Company
// DeleteEmployedModal component
export default {
  name: 'DeleteEmployedModal',
  props: {
    // Should dialog be showed
    show: false,
    // fetch employee type
    type: {
      // `String`
      type: String,
      // The default value is: `employee`
      default: 'employee'
    }
  },

  data: () => ({
    showDialog: false,
    endDate: null
  }),

  components: {
    ActionButton,
    DatePicker
  },

  watch: {
    /**
     * @vuese
     * Used to watch show prop and open modal
     */
    show(val) {
      this.showDialog = val
    },
  },

  methods: {
    /**
     * @vuese
     * Used to delete employe or apprentice based on type
     */
    deleteEmployed() {      
      const method = (this.type === 'apprentice') ? 'endApprenticeship' : 'endEmployment'

      API[method](this.$route.params.employee_id, {data: {endDate: this.endDate}})
        .then(response => {          
          this.$nextTick(() => {
            this.$router.push({name: 'CompanyEmployees', params: {id: this.$route.params.id}})
          })
        })
        .catch(error => {
          this.$events.fire('showError', this.$t('errors.delete-failure'))
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

